module.exports = __webpack_public_path__ + "static/media/bkg_beans.4a8231e3.png";